import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, Mail, Loader2 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      localStorage.setItem("admin_token", data.token);
      onLogin(data);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Identifiants invalides");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center border border-[#E60000]/30 bg-[#E60000]/10">
            <Lock className="w-7 h-7 text-[#E60000]" />
          </div>
          <h1 className="font-heading text-2xl font-bold uppercase text-white tracking-tight">
            Admin DJMIX
          </h1>
          <p className="font-body text-sm text-[#A3A3A3] mt-1">Panneau d'administration</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
          <div className="space-y-2">
            <Label className="text-white/70 text-xs uppercase tracking-widest font-body">Email</Label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#A3A3A3]" />
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@djmix.ca"
                required
                className="bg-black/50 border-red-900/30 text-white pl-10 h-11 rounded-none focus-visible:ring-2 focus-visible:ring-[#E60000]"
                data-testid="admin-email-input"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label className="text-white/70 text-xs uppercase tracking-widest font-body">Mot de passe</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#A3A3A3]" />
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="bg-black/50 border-red-900/30 text-white pl-10 h-11 rounded-none focus-visible:ring-2 focus-visible:ring-[#E60000]"
                data-testid="admin-password-input"
              />
            </div>
          </div>

          {error && (
            <p className="text-[#FF3333] text-sm text-center font-body" data-testid="login-error">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#E60000] hover:bg-[#FF3333] disabled:opacity-50 text-white text-sm font-bold uppercase tracking-[0.2em] py-4 transition-all duration-300 flex items-center justify-center gap-2"
            data-testid="admin-login-btn"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Connexion"}
          </button>
        </form>

        <div className="text-center mt-6">
          <a href="/" className="font-body text-xs text-[#A3A3A3] hover:text-[#E60000] transition-colors">
            Retour au site
          </a>
        </div>
      </div>
    </div>
  );
}
